import moment from 'moment';

import { BtrEventModel, TicketModel } from '@app/core/models';
import { ITicketApiModel } from '@app/core/models/api';

export class BtCostPercentageService {
  readonly FIXED_FEE = 0.3;
  readonly PERCENTAGE_FEE_DEFAULT = 2.9 / 100;

  // adding brightr business fee to ticket price 23/05/2023
  readonly BRIGHTR_FEE_DATE_1 = moment('2023-05-23T00:00:00Z').format();
  readonly PERCENTAGE_FEE_23_05_23 = 10.4 / 100;

  getNeededpercentage(
    price: number,
    event: BtrEventModel,
  ): { fixedFee: number; percentageFee: number } {
    const coefs = event.formula.coefs
      .map(item => ({
        ...item,
        threshold: item.threshold ? item.threshold / 100 : 0,
      }))
      .sort((a, b) => (a.threshold > b.threshold ? 1 : -1));
    let percentageFee: number;
    let fixedFee: number;
    for (const coef of coefs) {
      if (price >= coef.threshold) {
        fixedFee = coef.platformFixed + coef.stripeFixed;
        percentageFee = coef.platformPersentage + coef.stripePersentage;
      }
      if (!fixedFee || !percentageFee) {
        fixedFee = coef.platformFixed + coef.stripeFixed;
        percentageFee = coef.platformPersentage + coef.stripePersentage;
      }
    }
    return { fixedFee: fixedFee / 100, percentageFee: percentageFee / 100 };
  }

  calcBusinessProfit(event: BtrEventModel, price: number): number {
    const fees = this.getNeededpercentage(price / 100, event);
    return price / 100 - ((price / 100) * fees.percentageFee + fees.fixedFee);
  }

  calcBusinessProfitWithConsumerFee(
    event: BtrEventModel,
    price: number,
  ): number {
    const fees = this.getNeededpercentage(price / 100, event);
    return +((+price / 100) * (1 - fees.percentageFee) - fees.fixedFee)
      .toString()
      .match(/^-?\d+(?:\.\d{0,2})?/)[0];
  }
}
